import { useMemo } from 'react';
import { useSnapshot } from 'valtio';
import { IntelligenceSectionTitle } from '../common';
import { physicalInfrastructureLayerIds } from '../common/config';
import { getRollupCount } from '../common/getRollupCount';
import Hydrology from '../common/Hydrology';
import IntelligenceSection from '../common/IntelligenceSection';
import Table from '../common/Table';
import store from '../store';

export default function PhysicalInfrastructure() {
  const { config } = useSnapshot(store) as typeof store;

  const featureCount = useMemo(() => getRollupCount(config, physicalInfrastructureLayerIds), [config]);

  return (
    <IntelligenceSection title={IntelligenceSectionTitle.PhysicalInfrastructure} featureCount={featureCount}>
      <Hydrology />
      <Table
        label="Bridges"
        columns={['Name', 'Bridge']}
        rows={[
          {
            layerId: 'landUseStateHighwayBridges',
            columnProperties: ['NAME', 'BRIDGE'],
          },
        ]}
        emptyMessage="No known bridges in the project area."
        sortBy="NAME"
      />

      <Table
        label="Civic Buildings"
        columns={['Name']}
        rows={[
          { layerId: 'otherHospitals', columnProperties: ['USER_Hospi'] },
          { layerId: 'otherK12Schools', columnProperties: ['NAME'] },
          {
            layerId: 'otherCollegesUniversities',
            columnProperties: ['NAME'],
          },
          { layerId: 'otherCSCDSchools', columnProperties: ['School'] },
          { layerId: 'otherCSCDUniversityLands', columnProperties: ['NAME'] },
        ]}
        emptyMessage="No known civic buildings in the project area."
      />

      <Table
        label="Energy Infrastructure"
        columns={['Name']}
        rows={[
          { layerId: 'geotechnicalOilGasWells', columnProperties: ['API'] },
          {
            layerId: 'geotechnicalOilGasRefineriesProcessingPlants',
            columnProperties: ['Company'],
          },
          {
            layerId: 'geotechnicalPowerPlants',
            columnProperties: ['Utility_Name'],
          },
        ]}
        emptyMessage="No known energy infrastructure in the project area."
      />
    </IntelligenceSection>
  );
}
